<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosLbuCustomerLabelManage"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="客户名称">
              <a-input v-model:value="queryForm.customerName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="客户ID">
              <a-input v-model:value="queryForm.cosId" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="变更标签">
              <CustomerLabelCascader appId="cos_lbu" :onlyCommon=false v-model:value="queryForm.labelId" />
            </dc-form-item>
            <dc-form-item label="操作人">
              <UserSelect v-model:value="queryForm.labelBy" placeholder="请选择" allowClear />
            </dc-form-item>
            <dc-form-item label="操作时间">
              <cos-range-picker v-model:startTime="queryForm.startTime" v-model:endTime="queryForm.endTime" />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button type="primary" @click="handleAdd()" v-permission="'lbu_customer_label_add_btn'">变更标签</a-button>
          <ImportBtn
            action="/lbu/api/clueCustomer/label/import"
            templateUrl="/lbu/api/clueCustomer/label/template/download"
            @success="success('search')"
            v-permission="'lbu_customer_label_import_btn'"
            >导入</ImportBtn
          >
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'label'">
            <p>{{ record.label ? record.label.map((item) => item.labelName ).join('、') : '--' }}</p>
          </template>
          <!-- <template v-if="column.dataIndex === 'lastLabel'">
            <p>{{ record.lastLabel ? record.lastLabel.map((item) => item.labelName ).join('、') : '--' }}</p>
          </template> -->
        </template>
      </cos-table>

      <CustomerLabelAddModel ref="addRef" @fetch="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">

import ImportBtn from '@/components/ImportBtn'
import { reactive, ref, computed } from 'vue'
import { customerLabelList } from '@/api/yuntuSales/customerLabelManage'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import CustomerLabelAddModel from './CustomerLabelAddModel.vue'

const tableRef = ref()
const queryForm = reactive({})
const addRef = ref()
const handleAdd = () => {
  addRef.value?.init()
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await customerLabelList({ ...params })
  callBack(res)
}
const columns = computed(() => [
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '客户ID', dataIndex: 'cosId', width: 200 },
  // { title: '原标签', dataIndex: 'lastLabel' },
  { title: '标签', dataIndex: 'label' },
  { title: '操作人', dataIndex: 'labelByName' },
  { title: '操作时间', dataIndex: 'labelTime', width: 150 }
])
</script>
<script lang="ts">
export default { name: 'DcCosLbuCustomerLabelManage' }
</script>
<style scoped></style>
